import { FC } from 'react';
import { $Formutil, connect } from 'react-bootstrap-formutil';
import Alert from 'components/base/Alert';
import { Fade } from 'components/Transition';
import type { CustomerInfoType } from 'types/customer';
import './style.scss';

export interface RevenueFormProps {
    disabled?: boolean;
    $formutil: $Formutil;
    customerInfo?: CustomerInfoType;
    name?: string;
}

const RevenueForm: FC<RevenueFormProps> = props => {
    const { customerInfo, $formutil, name } = props;
    const { id_no } = customerInfo || {};

    return (
        <div className="revenue-form-root">
            <h3 className="open-title mt-0">{__('INTERNAL REVENUE SERVICE CERTIFICATION')}</h3>
            <div className="revenue-desc">
                <p className="revenue-desc-item">
                    <span className="revenue-desc-label">{__('Name:')}</span>
                    <span className="revenue-desc-content">{name}</span>
                </p>
                <p className="revenue-desc-item">
                    <span className="revenue-desc-label">{__('Social Security Number: ')}</span>
                    <span className="revenue-desc-content">{id_no}</span>
                </p>
            </div>
            <div className="revenue-statement">
                <h4 className="revenue-statement-title">{__('Under penalties of perjury, I certify that:')}</h4>
                <p>
                    {__(
                        'The number shown on this form is my correct taxpayer identification number (or I am waiting for a number to be issued to me).'
                    )}
                </p>
                <p>
                    {__(
                        'I am not subject to backup withholding because: (a) I am exempt from backup withholding, or (b) I have not been notified by the Internal Revenue Service (IRS) that I am subject to backup withholding as a result of a failure to report all interest or dividends, or (c) the IRS has notified me that I am no longer subject to backup withholding.'
                    )}
                </p>
                <p>{__('I am a U.S. citizen or other person in the United States.')}</p>
                <p>
                    {__(
                        'The Internal Revenue Service does not require your consent to any provision of this document other than the certifications required to avoid backup withholding.'
                    )}
                </p>
            </div>
            <div className="desc">
                {__(
                    'BY CLICKING ON “CONTINUE” YOU (I) CERTIFY, UNDER PENALTY OF PERJURY THAT THE FOREGOING STATEMENTS ON THE IRS CERTIFICATION ARE TRUE AND CORRECT; (II) AGREE IT REPRESENTS YOUR DIGITAL SIGNATURE, WHICH IS THE EQUIVALENT OF YOUR WRITTEN SIGNATURE AND (III) CONSENT TO THE USE OF ELECTRONIC RECORDS TO EVIDENCE YOUR CERTIFICATION/AGREEMENT.'
                )}
            </div>
            <Fade exit={false} in={$formutil.$invalid}>
                <Alert variant="danger" className="mt-3">
                    {__('You need to confirm all the information to continue to the next page')}
                </Alert>
            </Fade>
        </div>
    );
};

export default connect(RevenueForm);
